export default __webpack_public_path__ + "static/media/Willow_9781846161902.540b7a9e.jpg";